export var NativeAction;
(function (NativeAction) {
    NativeAction["ROUTE"] = "ROUTE";
    NativeAction["LINK"] = "LINK";
    NativeAction["GO_BACK"] = "GO_BACK";
})(NativeAction || (NativeAction = {}));
